import { AiCreditUsageLink } from '@/components/shared/AiCreditUsageLink'
import { Button } from '@/components/ui/button'

const LOCK_FOLLOW_UP = "If you're happy with this, click Lock Strategy below."
const STRATEGY_FIELDS = new Set(['primaryStrategy', 'secondaryStrategy'])

function insightContent(content = '') {
  return content.replace(LOCK_FOLLOW_UP, '').trim()
}

function strategySuggestions(recommendation) {
  return (recommendation?.message?.fieldSuggestions || []).filter(({ field }) => (
    STRATEGY_FIELDS.has(field)
  ))
}

export function StrategyRecommendation({
  operatingPreference,
  recommendation,
  isLoading = false,
  isBusy = false,
  error,
  onGenerate,
  onRetry,
  onApplySuggestion,
}) {
  if (!operatingPreference) return null

  const suggestions = strategySuggestions(recommendation)
  const allApplied = suggestions.length > 0
    && suggestions.every(({ status }) => status === 'applied')
  let generateLabel = "Generate Rob's Recommendation"
  if (isLoading) {
    generateLabel = 'Generating recommendation…'
  } else if (isBusy) {
    generateLabel = 'Ask Rob is responding…'
  }

  return (
    <section className="space-y-4 rounded-lg border border-border bg-card p-4">
      <div>
        <p className="mb-1 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
          System Insight
        </p>
        <p className="text-sm text-foreground">
          {recommendation
            ? insightContent(recommendation.message.content)
            : 'Ask Rob to assess your locked targets and operating style before choosing a strategy.'}
        </p>
      </div>

      {suggestions.map((suggestion) => (
        <div key={suggestion.id} className="border-t border-border pt-4">
          <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
            {suggestion.label}
          </p>
          <p className="mt-1 text-sm font-bold text-foreground">
            {suggestion.displayValue || suggestion.suggestedValue}
          </p>
          {suggestion.status === 'pending' ? (
            <Button
              type="button"
              size="xs"
              className="mt-3"
              aria-label={`Apply ${suggestion.label}`}
              onClick={() => onApplySuggestion?.(recommendation.messageIndex, suggestion.id)}
            >
              Apply
            </Button>
          ) : (
            <p className="mt-2 text-xs font-semibold text-muted-foreground">
              {suggestion.status === 'applied'
                ? 'Applied to form'
                : 'Unavailable after primary selection'}
            </p>
          )}
        </div>
      ))}

      {allApplied ? <p className="text-xs text-foreground">{LOCK_FOLLOW_UP}</p> : null}

      {error ? (
        <div className="flex items-start justify-between gap-3">
          <p className="text-xs text-destructive">
            {error} <AiCreditUsageLink error={error} />
          </p>
          {onRetry ? (
            <Button type="button" variant="outline" size="xs" onClick={onRetry}>
              Retry
            </Button>
          ) : null}
        </div>
      ) : null}

      {!recommendation && !error ? (
        <div className="space-y-2">
          <Button type="button" disabled={isBusy} onClick={onGenerate}>
            {generateLabel}
          </Button>
          <p className="text-[11px] text-muted-foreground">Uses Judgement Credit</p>
        </div>
      ) : null}
    </section>
  )
}
